// @ts-nocheck
/* eslint-enable */
// App
import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

// Misc / utils
import appUtils from 'app/shared/utils/appUtils';
import * as S from './styles';

const MapView = ({ ariaLabel, children, dropdownId, onClose, modalRef, isVisible }) => {
  const buttonRef = useRef(null);

  useEffect(() => {
    if (buttonRef.current) {
      buttonRef.current.focus();
    }

    if (isVisible) {
      appUtils.lockVerticalScrolling({ isForPortal: true });
    } else {
      appUtils.unlockVerticalScrolling();
    }
  }, [isVisible]);

  // Esc key will close filter modal
  const handleOnKeyDown = (e) => {
    return e.keyCode === 27 && onClose();
  };

  return ReactDOM.createPortal(
    <S.Overlay
      id={dropdownId}
      role="dialog"
      aria-label={ariaLabel}
      aria-modal="true"
      tabIndex="-1"
      onKeyDown={handleOnKeyDown}
      isVisible={isVisible}
      ref={modalRef}
    >
      {children}
    </S.Overlay>,
    document.getElementById('modal-root'),
  );
};

export default MapView;
